import { INavData } from '@coreui/angular-pro';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
  },
  {
    name: 'Recomendaciones',
    url: '/recommendation',
    iconComponent: { name: 'cilMedicalCross' },
  },
  {
    name: 'Notificaciones',
    url: '/notifications',
    iconComponent: { name: 'cil-bell' },
  },
  {
    name: 'Administradores',
    url: '/admin-users',
    iconComponent: { name: 'cilPeople' },
  },
  {
    name: 'Política de versión',
    url: '/app-version-policy',
    iconComponent: { name: 'cilSettings' },
  },
  {
    name: 'Monitoreo',
    url: '/monitoring',
    iconComponent: { name: 'cilChart' },
  }
];
